import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../../mensajes';

import { Dimmer } from "../../spinner";

import { validaSoloNumero, validaNumeroTelefono, validaEmail } from '../../../util/varios';
import axios from 'axios';
import moment from 'moment';

export const ImpporDeuda = (props) => {

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const btnSalir = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [titulo2, setTitulo2] = useState();
    const [msg2, setMsg2] = useState();
    const [clases, setClases] = useState();
    const [visibleF, setVisibleF] = useState('hidden');
    const [activate, setActivate] = useState(false);
    const txtAnio = useRef();
    const txtActivo = useRef();
    const txtInactivo = useRef();
    const txtTodos = useRef();
    const txtTipo = useRef();
    const txtClaseVh = useRef();


    let token = localStorage.getItem('jwtToken');
    let op = require('../../../../src/modulos/datos');

    const selectClaseVehiculos = () => {

        let endpoint = `${op.conexion}/api/catalogo/clasevehiculos`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                setClases(response.data);
                setActivate(false);
            }

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg('Notificacion', error.response.data.message, 'error', 'Aceptar')
            setMostrar(true)
            setActivate(false);

        })

    }

    useEffect(() => {

        selectClaseVehiculos();

    }, []);

    const cancelar = (e) => {
        e.preventDefault();
        blanquear();
        props.onHideCancela();

    }

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtTodos.current.checked === false && txtTipo.current.checked === false) {
            setTitulo('Error');
            setMsg('Seleccione el Tipo de consulta');
            sigue = false;
            txtTodos.current.focus();
            setMostrar(true);
        } else if (txtAnio.current.value === "") {
            setTitulo('Error');
            setMsg('Seleccione la Fecha');
            sigue = false;
            txtAnio.current.focus();
            setMostrar(true);
        } else if (txtActivo.current.checked === false && txtInactivo.current.checked === false) {
            setTitulo('Error');
            setMsg('Seleccione el Estatus de la Consulta');
            sigue = false;
            txtActivo.current.focus();
            setMostrar(true);
        } else if (sigue === true) {
            imprimirReporte();
        }
    }

    const blanquear = () => {

        setMostrar1(false);
        setActivate(false);
        setVisibleF('hidden');
        setMsg('');

    }

    const onChange = (event) => {

        if (event.target.name === "inlineRadioOptions") {
            if (txtTipo.current.checked) {
                setVisibleF('visible');
            } else if (txtTodos.current.checked) {
                setVisibleF('hidden');
                txtClaseVh.current.value = "";
            }
        }
    }


    const imprimirReporte = () => {

        var sigue = true;

        if (sigue) {
            var reporte = '';
            var fecha = moment.utc(txtAnio.current.value).format("DD-MM-YYYY");

            if (props.tiporepd === 2) {

                reporte = 'ListVehicDeuda';
                var sql;
                var sql2 = null;
                var sql3 = "";

                if (txtTodos.current.checked) {
                    sql = " FCHPAGO ISNULL OR FCHPAGO > '" + fecha + "'";
                    sql2 = "";
                    sql3 = "status IN (" + (txtActivo.current.checked ? "0," : "2,") + (txtInactivo.current.checked ? "1" : "2") + ")";
                    
                } else if (txtTipo.current.checked) {
                    sql = "(FCHPAGO ISNULL OR FCHPAGO > '" + fecha + "')";
                    sql2 = "CLASIFICADO POR" + " " + "'" + txtClaseVh.current.value.trim() + "'";
                    sql3 = "Descripcion =" + "'" + txtClaseVh.current.value.trim() + "'" + " AND status IN  (" + (txtActivo.current.checked ? "0," : "2,") + (txtInactivo.current.checked ? "1" : "2") + ")";
                    
                }
            }
            window.open(op.reportes + "/impuestovehiculo?" + "reporte=" + reporte + "&sql=" + sql + "&sql2=" + sql2 + "&sql3=" + sql3, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");





        }

    };

    const salir = () => {

        props.onHideCancela();
    }

    const handleCloseMensa = (e) => {
        e.preventDefault();
        setMostrar(false);

    }


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {

            }}

        >
            <Modal.Header className='azulGradiant' style={{ height: '40px'}}>
                <div style={{ color: "#fff", fontSize: 20 }}>Impresión General de Contribuyentes con Deudas</div>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={salir}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#ffffff", color: "" }}>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar} onHide={handleCloseMensa}
                />
                <MensajeSiNo titulo={titulo2} mensaje={msg2}
                    show={mostrar1} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div style={{ height: "auto", overflow: "auto" }}>

                <fieldset className=' row col-md-12 border-azul rounded mx-auto d-flex justify-content-between'>
                        <legend className="float-none w-auto " >{props.titulo2}</legend>
                        <div className="container row col-md-12">
                        <div className="col-md-4 row">
                            <div className="form-check col">
                                <input className="form-check-input my-auto" type="radio" ref={txtTodos} name="inlineRadioOptions" defaultChecked onChange={onChange} id="inlineRadio1" value="option1" />
                                <label className="form-check-label" for="inlineRadio1">Todo</label>
                            </div>
                            <div className="form-check col">
                                <input className="form-check-input my-auto" type="radio" ref={txtTipo} name="inlineRadioOptions" onChange={onChange} id="inlineRadio2" value="option2" />
                                <label className="form-check-label" for="inlineRadio2">Por Tipo</label>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="input-group mb-3 input-group-sm w-100" style={{ visibility: visibleF }}>
                                <label className="input-group-text" for="inputGroupSelect01">Clasificación</label>
                                <select name='idclasevehiculo' ref={txtClaseVh} onChange={onChange} className="form-control text-uppercase" id="inputFechaReg">
                                    <option value={""}>SELECCIONAR CLASE DEL VEHICULO</option>
                                    {clases && clases.map((item, index) => (
                                        <option key={index} value={item.descripcion} > {item.descripcion} </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    
                    <div className="container row col-md-12 mx-auto" style={{ fontFamily: 'Lucida Sans', fontWeight: 600 }}>
                        <div className="input-group input-group-sm mb-3 col-md-5">
                            <span className="input-group-text" id="inputGroup-sizing-sm">Inscrito al Día</span>
                            <input type="date" className="form-control text-uppercase" ref={txtAnio} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                        </div>
                        <div className="was-validated col-md-7 row">
                            <div className="form-check my-auto col-md-3">
                                <input type="checkbox" className="form-check-input my-auto" id="validationFormCheck1" ref={txtActivo} required />
                                <label className="form-check-label" for="validationFormCheck1">Activo</label>
                                <div className="invalid-feedback"></div>
                            </div>
                            <div className="form-check my-auto col-md-3">
                                <input type="checkbox" className="form-check-input my-auto" id="validationFormCheck2" ref={txtInactivo} required />
                                <label className="form-check-label" for="validationFormCheck2">Inactivo</label>
                                <div className="invalid-feedback"></div>
                            </div>
                        </div>
                    </div>
                    </fieldset>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} onClick={onChangeValidar} className="btn btn-primary btn-sm rounded-pill"><i className="fas fa-print">  Imprimir</i></button>
                <button ref={btnSalir} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill"><i className="fa fa-sign-out">  Salir</i></button>
            </Modal.Footer>
        </Modal>
    );
}